import { Component, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SnackService } from '@shared/services/snack.service';
import { IReportTemplate } from '@shared/interfaces';
import { ReportTemplateService } from '@shared/services/report-template.service';

@Component({
    selector: 'app-template-editor-confirm',
    templateUrl: './template-editor-confirm.component.html',
    styleUrls: ['./template-editor-confirm.component.scss'],
    standalone: false
})
export class TemplateEditorConfirmComponent {
    formGroup: UntypedFormGroup;

    constructor(
        public dialogRef: MatDialogRef<TemplateEditorConfirmComponent>,
        @Inject(MAT_DIALOG_DATA) public data: { item: IReportTemplate; mode: string },
        private fb: UntypedFormBuilder,
        private templateService: ReportTemplateService,
        private snack: SnackService
    ) {
        this.buildForm();
    }

    protected createItem(): void {
        if (this.formGroup.valid) {
            this.dialogRef.close({ ...this.data.item, ...this.formGroup.getRawValue() });
        } else {
            this.snack.openSnackBarError('Please check your inputs.');
        }
    }

    private buildForm() {
        this.formGroup = this.fb.group({
            title: [{ value: this.data.item.title ?? '', disabled: this.data.mode === 'edit' }, Validators.required],
            description: '',
            periodYear: [
                {
                    value: this.data.item.periodYear ?? new Date().getFullYear(),
                    disabled: this.data.mode === 'edit'
                },
                Validators.required
            ]
        });
    }
}
